/**
 * Accrediting-body marks, ingested 2026-08-08 into sites/biet/accreditation/.
 *
 * bietdvg.edu publishes none of these — it hosts only its own crest — so each
 * was taken from the body's own site: aicte-india.org, naac.gov.in,
 * nbaind.org, ugc.gov.in and vtu.ac.in. BIET holds every one of them; the
 * institute's masthead reads "Approved by AICTE, New Delhi | Accredited by
 * NAAC with 'A' grade and NBA (UG Programmes) | Recognized by UGC, New Delhi
 * under 2(F) and 12(B)", affiliated to VTU, Belagavi.
 *
 * Each file is the emblem alone, cropped from a horizontal lockup. That is not
 * cosmetic: AICTE's and VTU's published wordmarks are set in white for dark
 * headers and vanish entirely on the white badge these sit in. NBA's and UGC's
 * lockups carry tagline text that is illegible below about 100px.
 *
 * These are the highest resolutions the bodies publish — 65 to 140px square.
 * They are displayed at 34px so they stay sharp on a 2x screen; do not scale
 * them up, and note the pipeline will not upscale them either.
 */
import type { Media } from "@zivin-labs/site-content";

export const AICTE_LOGO: Media = {
  url: "sites/biet/accreditation/aicte.png",
  alt: "All India Council for Technical Education",
  width: 73,
  height: 73,
};

export const NAAC_LOGO: Media = {
  url: "sites/biet/accreditation/naac.png",
  alt: "National Assessment and Accreditation Council",
  width: 65,
  height: 65,
};

export const NBA_LOGO: Media = {
  url: "sites/biet/accreditation/nba.png",
  alt: "National Board of Accreditation",
  width: 102,
  height: 102,
};

/**
 * `ugc-mark`, not `ugc`: the first upload had an opaque white background, and
 * once that was stripped the CDN kept serving the cached derivative for the
 * original key. A new key is the cheap way past a warm cache.
 */
export const UGC_LOGO: Media = {
  url: "sites/biet/accreditation/ugc-mark.png",
  alt: "University Grants Commission",
  width: 80,
  height: 80,
};

export const VTU_LOGO: Media = {
  url: "sites/biet/accreditation/vtu.png",
  alt: "Visvesvaraya Technological University, Belagavi",
  width: 120,
  height: 120,
};
